import { readonly, ref } from "vue";

import { useTrialCountdown } from "@/lib/composable/freeTrail/useTrialCountdown";

import type {
  TrialResult,
} from "@/lib/utils/free_trials";

const sharedTrialDays = ref<TrialResult>(false);

let initialized = false;

export function useGlobalTrialState(
  trialData: any,
  userStore: any,
  options?: {
    navigateToBilling?: () => void;
    setIsTrailAccount?: (value: boolean) => void;
    setIsTrialExpired?: (value: boolean) => void;
  }
) {
  /**
   * Shared updater
   */
  const revokeTrialAccess = () => {
    userStore.setSingleProductAccess('marketing', false);
    userStore.setSingleProductAccess('service', false);
    userStore.setSingleProductAccess('commerce', false);
  
    if (!userStore.getProductAccess('neto') && !userStore.getProductAccess('mhc')) {
      options?.navigateToBilling?.();
    }
  };
  
  const updateState = (trialDaysValue: TrialResult) => {
    sharedTrialDays.value = trialDaysValue;
  
    if (trialDaysValue) {
  
      const isExpired = parseInt(trialDaysValue.maxDays) <= 0;
      options?.setIsTrialExpired?.(isExpired);
  
      if (isExpired) {
        revokeTrialAccess();
      }
  
      return;
    }

    if (!userStore.hasActivePackage) {
      options?.setIsTrialExpired?.(true);
      revokeTrialAccess();
    } else {
      options?.setIsTrialExpired?.(false);
    }
  };

  if (!initialized) {
    initialized = true;

    const { trialDays } = useTrialCountdown(
      () => trialData,
      () =>
        new Date(
          trialData?.timestamp || new Date().toISOString()
        ).toISOString()
    );

    /**
     * IMPORTANT:
     * Initial synchronous update
     */

    updateState(trialDays.value);

    
  }

  return {
    trialDays: readonly(sharedTrialDays),
  };
}